import type { ProductByVariantSkusCategory } from '../queries/useProductByVariantSkusQuery'

// Constructor ORs `group_id` values, so any set wider than a single leaf
// weakens the filter — an ancestor (worst case a root) matches most of the
// catalog. Mirrors mb3-frontend's buildCategoryBreadcrumbs +
// toConstructorGroupIds: walk each category's parent chain within the list,
// keep the longest chain (first wins a depth tie, preserving the product
// service's order), and filter on that chain's leaf only.
export function getDeepestCategorySlug(
  categories: ProductByVariantSkusCategory[],
): string | undefined {
  const byId = new Map(
    categories
      .filter((category) => Boolean(category.categoryId))
      .map((category) => [category.categoryId as string, category]),
  )

  let deepest: ProductByVariantSkusCategory | undefined
  let deepestDepth = 0

  for (const category of categories) {
    let depth = 0
    let current: ProductByVariantSkusCategory | undefined = category

    // A real chain can never exceed the list length; the cap breaks parent cycles.
    while (current && depth < categories.length) {
      depth += 1
      current = current.parentCategoryId
        ? byId.get(current.parentCategoryId)
        : undefined
    }

    if (depth > deepestDepth) {
      deepest = category
      deepestDepth = depth
    }
  }

  return deepest?.slug ?? undefined
}
